// API base URL configuration.
// Every site (subdomain, custom domain, legacy port, dev preview) talks to
// its own same-origin backend. Only plain `npm start` dev on :3000 falls back.
function sameOrigin(path) {
  try {
    if (window.location.origin && !window.location.origin.startsWith('http://localhost:3000')) {
      return window.location.origin + path;
    }
  } catch {}
  return null;
}
const API_BASE = sameOrigin('/api') || 'http://77.90.45.115:8001/api';
const STORAGE_BASE = sameOrigin('/storage') || 'http://77.90.45.115:8001/storage';

export { API_BASE, STORAGE_BASE };
